import { render, staticRenderFns } from "./CreditNotePayment.vue?vue&type=template&id=2be5728d&lang=pug&"
import script from "./CreditNotePayment.vue?vue&type=script&lang=js&"
export * from "./CreditNotePayment.vue?vue&type=script&lang=js&"
import style0 from "./CreditNotePayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CreditNotePayment.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VTextField,
})
